<template>
  <!-- FT-191 REQ-03: после полного входа на общем компьютере без PIN — предложить задать PIN.
       Уровень App: форма входа к этому моменту уже уводит на стартовую страницу. -->
  <v-dialog :value="open" max-width="460" persistent>
    <v-card class="pin-setup">
      <v-toolbar dark color="primary" flat dense>
        <v-icon left>mdi-dialpad</v-icon>
        <v-toolbar-title>{{ $t("pin_settings.setup_title") }}</v-toolbar-title>
      </v-toolbar>
      <v-card-text class="pt-4">
        <p class="pin-setup__text">{{ $t("pin_settings.setup_text") }}</p>
        <pin-form @saved="close" />
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn text data-test="pin-setup-later" @click="close">{{ $t("pin_settings.later") }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import PinForm from "./PinForm.vue";

export default {
  name: "PinSetupDialog",
  components: { PinForm },
  computed: {
    open() {
      return this.$store.getters["deviceLock/pinSetupRequested"];
    },
  },
  methods: {
    close() {
      this.$store.commit("deviceLock/CLEAR_PIN_SETUP");
    },
  },
};
</script>

<style scoped>
.pin-setup__text {
  margin-bottom: 16px;
  line-height: 1.5;
}
</style>
